import ControlState from '../../Shared/controlState';
import PageState from '../../Shared/pageState';
import { WorkflowEngineState, UpdatePages } from '../workflowEngineReducer';
import ControlKind from '../../Shared/controlKind';

export default (state: WorkflowEngineState, payload: UpdatePages) => {
  payload.newPages.forEach((page: PageState) => {
    page.controls.forEach((control: ControlState) => {
      if (control.kind === ControlKind.PAGE) {
        control.building = false;
        return;
      }
    });
  });

  return {
    ...state,
    pages: payload.newPages,
    lastUpdatedDate: payload.lastModifyDate,
    lastUpdatedBy: payload.lastModifyBy
  };
};
